import {
	getRiskTemplateCatalog,
	getRiskTemplateCatalogResolved,
	getRiskTemplateCatalogRejected,
} from '@Actions/RiskTemplateCatalog.actions';
import { put, retry, takeLatest } from '@redux-saga/core/effects';
import { getRiskTemplateCatalogApi } from '@Services/RiskTemplateCatalog/RiskTemplateCatalog.services';
import { RiskTemplateCatalogEntry } from '@Types/riskTemplateCatalog.types';
import { AxiosResponse } from 'axios';
import { AnyAction } from 'redux';

export function* getRiskTemplateCatalogSaga(action: AnyAction): Generator {
	try {
		const { systemTypeId, assetTypeId } = action.payload;
		const response = (yield retry(
			3,
			1500,
			getRiskTemplateCatalogApi,
			systemTypeId,
			assetTypeId,
		)) as AxiosResponse<RiskTemplateCatalogEntry[]>;

		yield put(getRiskTemplateCatalogResolved(response.data));
	} catch {
		yield put(getRiskTemplateCatalogRejected());
	}
}

function* watchRiskTemplateCatalogSagas() {
	yield takeLatest(getRiskTemplateCatalog, getRiskTemplateCatalogSaga);
}

const sagaArray = [watchRiskTemplateCatalogSagas()];

export default sagaArray;
